import { Base } from '../base-component';
import './tabs-standalone.component.scss';
import { MediaQueryService } from '../../services/media-query.service';
import * as $ from 'jquery';

export class TabsStandalone extends Base {

    tabComponent: JQuery<HTMLElement>;
    activeTab: JQuery<HTMLElement>;
    tabsContent: Array<HTMLElement>;
    accordionTriggers: Array<HTMLElement>;
    tabTriggers: Array<HTMLElement>;
    activeTabTrigger: JQuery<HTMLElement>;
    autoHeight: string;

    constructor(element: Element) {

        super(element);

    }

    init() {
        if (this.element.getAttribute('data-autoheight')) {
            this.autoHeight = this.element.getAttribute('data-autoheight').toString();
        }
        else {
            this.autoHeight = 'true';
        }
        this.tabComponent = $(this.element);
        this.tabsContent = Array.from(this.tabComponent.find('.tabs-standalone__item-content'));

        setTimeout(() => {
            this.equalHeights();
        }, 100);

        this.initTabs();

        this.tabTriggers = Array.from(this.tabComponent.find('.js-tab-trigger'));
        this.accordionTriggers = Array.from(this.tabComponent.find('.js-accordion-trigger'));
        this.activeTabTrigger = this.tabComponent.find('.tabs-standalone__item--active');
        this.activeTab = this.tabComponent.find('.tabs-standalone__item-content--active');

    }

    bindEvents() {

        this.tabTriggers.map((item) => item.addEventListener('click', (event) => {

            this.toggleTabs(event);

        }));

        this.accordionTriggers.map((item) => item.addEventListener('click', (event) => {

            this.stopVideos();

        }));

        window.addEventListener('resize', this.onResize.bind(this));

    }

    onResize() {

        setTimeout(() => {
            this.equalHeights();
        }, 100);

    }

    initTabs() {

        let tabs = this.tabComponent.find('.tabs-standalone__item');
        let tabsContent = this.tabsContent;

        for (let i = 0; i < tabs.length; i++) {

            let tabGuid = this.generateGuid();

            $(tabs[i]).attr('data-target', `tabs-standalone__item-${tabGuid}`);
            $(tabsContent[i]).attr('id', `tabs-standalone__item-${tabGuid}`);

        }

    }

    equalHeights() {
        if (this.autoHeight == 'true') {
            let elements = this.tabsContent;

            for (let i = 0; i < elements.length; i++) {
                elements[i].style.height = 'auto';
            }

            if (MediaQueryService.getMediaQuery() !== 'small' && MediaQueryService.getMediaQuery() !== 'x-small') {

                let tallestElement = 0;

                for (let i = 0; i < elements.length; i++) {
                    let el = elements[i];
                    let elHeight = el.offsetHeight;

                    if (elHeight > tallestElement) {
                        tallestElement = elHeight;
                    }
                }
                for (let i = 0; i < elements.length; i++) {

                    elements[i].style.height = `${tallestElement}px`;

                    if (!elements[i].classList.contains('tabs-standalone__item-content--active')) {
                        elements[i].style.height = '0';
                    }
                }
            }
        }
    }

    toggleTabs(event) {

        this.stopVideos();

        if (!$(event.currentTarget).hasClass('tabs-standalone__item--active')) {

            this.closeTab();

            this.activeTabTrigger = $(event.currentTarget);
            this.activeTab = this.tabComponent.find(`#${this.activeTabTrigger.attr('data-target')}`);

            this.openTab();

        }

        this.equalHeights();

    }

    generateGuid() {

        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {

            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);

        });

    }

    closeTab() {

        this.activeTabTrigger.removeClass('tabs-standalone__item--active');
        this.activeTab.removeClass('tabs-standalone__item-content--active');

    }

    openTab() {

        this.activeTabTrigger.addClass('tabs-standalone__item--active');
        this.activeTab.addClass('tabs-standalone__item-content--active');

    }

    debounce(func, wait, immediate) {
        let timeout;
        return function () {

            let context = this, args = arguments;
            let later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            let callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);

        };
    }

    stopVideos() {

        let videosVidavee = Array.from(this.element.querySelectorAll('video'));
        let videosYoutube = Array.from(this.element.querySelectorAll('#video__external'));

        videosVidavee.map((video: any)=>{
            if(video.player) {
                video.player.pause();
            }
        });

        videosYoutube.map((video: any)=>{
            //this.contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
            video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*')
            console.log(video);

    }

}


// WEBPACK FOOTER //
// ./components/tabs-standalone/tabs-standalone.component.ts